import { fromJS } from 'immutable';
import { getText } from 'helpers/app/getText';

export const actions = {
  ATTEMPT_GET_RECEIPT: 'ATTEMPT_GET_RECEIPT',
  ATTEMPT_GET_RECEIPT_SUCCEED: 'ATTEMPT_GET_RECEIPT_SUCCEED',
  ATTEMPT_GET_RECEIPT_FAILED: 'ATTEMPT_GET_RECEIPT_FAILED',
  ATTEMPT_UPDATE_RECEIPT: 'ATTEMPT_UPDATE_RECEIPT',
  ATTEMPT_UPDATE_RECEIPT_SUCCEED: 'ATTEMPT_UPDATE_RECEIPT_SUCCEED',
  ATTEMPT_UPDATE_RECEIPT_FAILED: 'ATTEMPT_UPDATE_RECEIPT_FAILED',
  ATTEMPT_SEARCH_RECEIPT: 'ATTEMPT_SEARCH_RECEIPT',
  ATTEMPT_SEARCH_RECEIPT_SUCCEED: 'ATTEMPT_SEARCH_RECEIPT_SUCCEED',
  ATTEMPT_SEARCH_RECEIPT_FAILED: 'ATTEMPT_SEARCH_RECEIPT_FAILED',
  ATTEMPT_RESET_NOTIFICATION_STATE: 'ATTEMPT_RESET_NOTIFICATION_STATE',
};

const defaultState = fromJS({
  receipt: {},
  error: {},
  receipts: [],
  isReceiptUpdated: false,
});

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case actions.ATTEMPT_RESET_NOTIFICATION_STATE:
      return state.set(payload.data, false).set('error', '');

    case actions.ATTEMPT_GET_RECEIPT:
      return state.set('error', {}).set('message', '')
.set('receipt', {});

    case actions.ATTEMPT_GET_RECEIPT_SUCCEED:
      return state
        .set('error', {})
        .set('message', '')
        .set('receipt', payload.data.length > 0 ? payload.data[0] : {});

    case actions.ATTEMPT_GET_RECEIPT_FAILED:
      return state.set('error', getText('notifications:ATTEMPT_GET_RECEIPT_FAILED_MSG'));

    case actions.ATTEMPT_UPDATE_RECEIPT:
      return state.set('error', '').set('isReceiptUpdated', false);

    case actions.ATTEMPT_UPDATE_RECEIPT_SUCCEED:
      return state.set('error', '').set('isReceiptUpdated', true);

    case actions.ATTEMPT_UPDATE_RECEIPT_FAILED:
      return state.set('error', getText('notifications:ATTEMPT_UPDATE_RECEIPT_FAILED_MSG'));

    case actions.ATTEMPT_SEARCH_RECEIPT:
      return state.set('error', {}).set('message', '')
.set('receipts', []);

    case actions.ATTEMPT_SEARCH_RECEIPT_SUCCEED:
      return state.set('error', {}).set('message', '')
.set('receipts', payload.data);

    case actions.ATTEMPT_SEARCH_RECEIPT_FAILED:
      return state.set('error', getText('notifications:ATTEMPT_SEARCH_RECEIPT_FAILED_MSG'));

    default:
      return state;
  }
};
